import React from "react";
import { FaRegWindowClose, FaTrashAlt } from "react-icons/fa";

const ConfirmEmailBox = ({ Modalclose, handleDelete }) => {
  return (
    <>
      <div className="modal-wrapper email-confirm-overlay" onClick={Modalclose}></div>
      <div className="modal-container email-confirm-box delete-box">
        <div className="close-icon">
          <FaRegWindowClose onClick={Modalclose} />
        </div>
        <div className="modal-body">
          <section className="email-confirm-section">
            <div className="email-confirm-content">
              <div className="icon-circle danger">
                <FaTrashAlt className="trash-icon" />
              </div>
              <h2>Confirm Deletion</h2>
              <p>
                Are you sure you want to delete this record? This action is <strong>permanent</strong> and cannot be undone.
              </p>
              <div className="delete-buttons">
                <button className="cancel-button btn btn-secondary" onClick={Modalclose}>
                  No 
                </button>
                <button className="confirm-button btn btn-danger" onClick={handleDelete}>
                  Yes
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ConfirmEmailBox;
